module.exports = __webpack_public_path__ + "static/media/scary_2.9d2a4e88.jpg";